/**
 * Cambiar Contraseña
 *
 * @author edmsamuel
 */
import React from 'react'
import { Form, Icon, Input, Button, message as Message, Popconfirm } from 'antd'
import Exception from '../Exception'
import Api from '../Api'

class RegistroForm extends React.Component {
  /**
   * Constructor
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props)
    this.update = this.update.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  /**
   * On Submit
   *
   */
  onSubmit(e) {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.update(values)
      }
    })
  }

  /**
   * Solicita al servidor que se verifiquen las credenciales
   *
   * @param {Object} credentials
   */
  update(credentials) {
    if (credentials.nuevaClave !== credentials.confirmacion) {
      return Message.info('Las contraseñas no coincidden')
    }

    const CloseLoading = Message.loading('Registrando', 0)
    Api.put('/usuarios/change_password', credentials)
      .then(response => {
        CloseLoading()
        Message.success(`Contraseña actualizada`)
        this.props.form.resetFields()

        if (this.props.onUpdateOk) {
          this.props.onUpdateOk(response.data)
        }
      })
      .catch(error => {
        CloseLoading()
        Message.error((new Exception(error)).toComponent())
      })
  }

  /**
   * Get Field
   *
   * @param {String} name
   */
  getField(name) {
    const options = {
      claveActual: {
        rules: [{ required: true, message: 'Contraseña Actual' }]
      },
      nuevaClave: {
        rules: [{ required: true, message: 'Nueva Contraseña' }]
      },
      confirmacion: {
        rules: [{ required: true, message: 'Confirmar' }]
      },
    }

    switch (name) {
      case 'claveActual':
        return this.props.form.getFieldDecorator(name, options[name])(
          <Input
            type='password'
            placeholder='Contraseña Actual'
            prefix={
              <Icon type='lock' />
            } />
        )

      case 'nuevaClave':
        return this.props.form.getFieldDecorator(name, options[name])(
          <Input
            type='password'
            placeholder='Nueva Contraseña'
            prefix={
              <Icon type='lock' />
            } />
        )

      case 'confirmacion':
        return this.props.form.getFieldDecorator(name, options[name])(
          <Input
            type='password'
            placeholder='Confirmar'
            prefix={
              <Icon type='lock' />
            } />
        )

      default:
        return null
    }
  }

  /**
   * Render
   *
   */
  render() {
    return (
      <Form onSubmit={this.onSubmit} className='login-form'>
        <Form.Item>{this.getField('claveActual')}</Form.Item>
        <Form.Item>{this.getField('nuevaClave')}</Form.Item>
        <Form.Item>{this.getField('confirmacion')}</Form.Item>
        <Form.Item>
          <Popconfirm title='¿Cambiar contraseña?' onConfirm={this.onSubmit}>
            <Button type='primary'>ACTUALIZAR</Button>
          </Popconfirm>
        </Form.Item>
      </Form>
    )
  }
}

const Registro = Form.create()(RegistroForm)
export default Registro
